var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconIonicMdOptions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.957,
    height: 25.957,
    viewBox: "0 0 25.957 25.957",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-md-options",
    "data-name": "Icon ionic-md-options",
    transform: "translate(25.957 25.957) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(0 16.686)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M0,0H15.759V1.854H0Z",
    transform: "translate(0 3.708)",
    fill: "#7bc2dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M0,0H4.635V1.854H0Z",
    transform: "translate(21.321 3.708)",
    fill: "#7bc2dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M3.708,7.387A1.869,1.869,0,0,1,1.854,9.27h0A1.869,1.869,0,0,1,0,7.387v-5.5A1.869,1.869,0,0,1,1.854,0h0A1.869,1.869,0,0,1,3.708,1.883Z",
    transform: "translate(16.686 0)",
    fill: "#7bc2dc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(0 8.343)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M0,0H4.635V1.854H0Z",
    transform: "translate(0 3.708)",
    fill: "#7bc2dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M0,0H15.759V1.854H0Z",
    transform: "translate(10.197 3.708)",
    fill: "#7bc2dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M3.708,7.387A1.869,1.869,0,0,1,1.854,9.27h0A1.869,1.869,0,0,1,0,7.387v-5.5A1.869,1.869,0,0,1,1.854,0h0A1.869,1.869,0,0,1,3.708,1.883Z",
    transform: "translate(5.562 0)",
    fill: "#7bc2dc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M0,0H15.759V1.854H0Z",
    transform: "translate(0 3.708)",
    fill: "#7bc2dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M0,0H4.635V1.854H0Z",
    transform: "translate(21.321 3.708)",
    fill: "#7bc2dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M3.708,7.387A1.869,1.869,0,0,1,1.854,9.27h0A1.869,1.869,0,0,1,0,7.387v-5.5A1.869,1.869,0,0,1,1.854,0h0A1.869,1.869,0,0,1,3.708,1.883Z",
    transform: "translate(16.686 0)",
    fill: "#7bc2dc"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIonicMdOptions);
export default __webpack_public_path__ + "static/media/Icon-ionic-md-options.bc7d9972036fd30e7b0cd62d18a835ea.svg";
export { ForwardRef as ReactComponent };